import { SITE_LLD_DOWNLOADED, SITE_LLD_FAILED, SITE_LLD_PENDING, SITE_LLD_SELECTED } from './types';
import SitesApiService from '../../services/api/SitesApiService';
import { rentsLldResetAction } from '../rentsLld/actions';
import { booksLldResetAction } from '../booksLld/actions';

const sitesLldPendingAction = () => (
  {
    type: SITE_LLD_PENDING,
  }
);

const sitesLldFailedAction = (error) => (
  {
    type: SITE_LLD_FAILED,
    payload: error,
  }
);

const sitesLldDownloadedAction = (sites) => (
  {
    type: SITE_LLD_DOWNLOADED,
    payload: sites,
  }
);

const sitesLldSelectedAction = (siteId) => (
  {
    type: SITE_LLD_SELECTED,
    payload: siteId,
  }
);

export function getSitesLld(authUserToken, role) {
  return (dispatch) => {
    dispatch(sitesLldPendingAction());
    return SitesApiService.getLldSites(authUserToken, role)
      .then(data => {
        dispatch(sitesLldDownloadedAction(data));
        return data;
      })
      .catch(error => {
        dispatch(sitesLldFailedAction(error));
        return error;
      });
  };
}

export function selectSiteLld(siteId) {
  return (dispatch) => {
    dispatch(sitesLldSelectedAction(siteId));
    dispatch(rentsLldResetAction());
    dispatch(booksLldResetAction());
    return true;
  };
}



// WEBPACK FOOTER //
// ./src/store/sitesLld/actions.js